Getaways = window.Getaways ?= {}
Getaways.FinePrintHandler ?= {}

Getaways.FinePrintHandler.init = (obj, done) ->
  $('a[href="#getaways-fineprint-tab"]').removeAttr('onclick')
  $('a[href="#getaways-fineprint-tab"]').bind 'click', ->
    $('.headerShortcut_fine_print').click()
  done()


module.exports = Getaways.FinePrintHandler
